import { SearchFilterType, SearchIndexLegacy, SearchSortParams, } from '@zurich/api/search';
export function getSearchIndexFromValue(value, searchIndices) {
    // inexact comparison to check string and number alike
    // eslint-disable-next-line eqeqeq
    return searchIndices.find((index) => index == value);
}
export const searchIndexLegacyMapping = {
    [SearchIndexLegacy.CLAIM]: 'claim',
    [SearchIndexLegacy.CONTRACT]: 'contract',
    [SearchIndexLegacy.EVENT]: 'event',
    [SearchIndexLegacy.LOCATION]: 'location',
    [SearchIndexLegacy.PARTY]: 'party',
    [SearchIndexLegacy.POSTALCODE]: 'postalcode',
    [SearchIndexLegacy.POSTBOX]: 'postbox',
    [SearchIndexLegacy.STREET]: 'street',
    [SearchIndexLegacy.LOG]: 'log',
};
export function getSearchIndicesFromArray(values, searchIndices) {
    if (!Array.isArray(values)) {
        return [];
    }
    // FIXME: remove this once nmp/portal have the same status as dataservice
    // this is just for compatibility with the previous searchIndex ids
    const migratedValues = values.map((value) => typeof value === 'number'
        ? searchIndexLegacyMapping[value]
        : value);
    return migratedValues.reduce((ids, id) => {
        // inexact comparison to check string and number alike
        // eslint-disable-next-line eqeqeq
        const indexId = searchIndices.find((index) => index == id);
        if (indexId !== undefined) {
            ids.push(indexId);
        }
        return ids;
    }, []);
}
export function createSearchFilter(field, values, filterType = SearchFilterType.TERM, indexId) {
    return {
        field: field,
        values: Array.isArray(values) ? values : [values],
        filterType,
        indexId,
    };
}
export function addSearchFilter(filters, field, values, type = SearchFilterType.TERM, indexId) {
    filters.push(createSearchFilter(field, values, type, indexId));
}
export function addSearchSortField(sortFields, field, order, format) {
    sortFields[field] = SearchSortParams.create(order, format);
}
export function hasSearchResultValue(result, field) {
    const value = getSearchResultValue(result, field);
    if (Array.isArray(value)) {
        return (value.filter((v) => v !== undefined && v !== null && v.length > 0)
            .length > 0);
    }
    return (value !== undefined &&
        value !== null &&
        typeof value === 'string' &&
        value.length > 0);
}
export function getSearchResultValue(result, field) {
    return result.values[field];
}
export function getSearchResultStringValue(result, field, defaultValue) {
    return (convertSearchResultValueToString(result.values[field] ?? undefined) ??
        defaultValue ??
        '');
}
export function getSearchResultHighlight(result, field, defaultValue, arrayIndex = 0) {
    const highlights = result.highlights[field] ?? undefined;
    return ((highlights && highlights[arrayIndex]) ||
        getSearchResultStringValue(result, field, defaultValue));
}
// Important: To garantuee that a valid enum value is returned, pass the validEnumValues parameter.
// Otherwise it's only garantueed, that the value is a string. If a conversion error occurs, defaultValue is returned.
export function getSearchResultStringEnum(result, field, validEnumValues, defaultValue) {
    const value = getSearchResultStringValue(result, field);
    if (!value ||
        (Array.isArray(validEnumValues) &&
            !validEnumValues.includes(value)) // just to circumvent typing problems, the check will be the same
    ) {
        return defaultValue;
    }
    return value; // leap of faith, but as small as possible given the function parameters passed
}
// Important: To garantuee that a valid enum value is returned, pass the validEnumValues parameter.
// Otherwise it's only garantueed, that the value is a number. If a conversion error occurs, defaultValue is returned.
export function getSearchResultNumberEnum(result, field, validEnumValues, defaultValue) {
    const value = getSearchResultValue(result, field);
    if (value === undefined)
        return undefined;
    if (value === null)
        return null;
    if (typeof value !== 'number' ||
        (Array.isArray(validEnumValues) &&
            !validEnumValues.includes(value)) // just to circumvent typing problems, the check will be the same
    ) {
        return defaultValue;
    }
    return value; // leap of faith, but as small as possible given the function parameters passed
}
// IMPORTANT: Null and undefined values are filtered out, so you can not depend on specfic value indices!
export function getSearchResultStringArrayValues(result, field) {
    const values = getSearchResultValue(result, field);
    if (!Array.isArray(values)) {
        const value = convertSearchResultValueToString(values);
        return value !== null && value !== undefined ? [value] : [];
    }
    return values.filter((v) => v !== null && v !== undefined);
}
export function convertSearchResultValueToString(value, arrayIndex = 0) {
    if (value === undefined)
        return undefined; // TODO: hey, typescript! why can't we return value here?
    if (value === null)
        return null;
    const singleValue = Array.isArray(value) ? value[arrayIndex] : value;
    if (typeof singleValue === 'number') {
        return singleValue.toString();
    }
    return singleValue;
}
